import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2 text-warning text-caption"
}
const _hoisted_2 = {
  key: 0,
  class: "text-caption mb-3 ml-1"
}
const _hoisted_3 = {
  key: 1,
  class: "text-caption mb-3 ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.loading,
      title: "Loading..."
    }, null, 8 /* PROPS */, ["isActive"]),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "group-management-container d-flex flex-column"
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" App Context Toggle "),
        _createVNode(_component_v_row, { class: "flex-grow-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_toggle, {
                  modelValue: $setup.appContext,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.appContext) = $event)),
                  mandatory: "",
                  color: "primary",
                  density: "comfortable"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { value: "POINT" }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("POINT")
                      ])),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, { value: "Operation" }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("Operation")
                      ])),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_row, {
          class: "mt-2 flex-grow-1",
          style: {"overflow":"hidden","min-height":"0"}
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Groups Table "),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "5",
              class: "d-flex",
              style: {"height":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "text-left d-flex flex-column",
                  style: {"width":"100%","overflow":"hidden"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: $setup.groupHeaders,
                      items: $setup.groups,
                      loading: $setup.loading,
                      density: "comfortable",
                      class: "elevation-0 flex-grow-1",
                      style: {"overflow-y":"auto"},
                      "no-data-text": "No groups found",
                      "items-per-page": "-1",
                      "hide-default-footer": "",
                      hover: "",
                      "fixed-header": "",
                      height: "100%",
                      "onClick:row": _cache[1] || (_cache[1] = (_, row) => $setup.selectGroup(row.item))
                    }, {
                      top: _withCtx(() => [
                        _createVNode(_component_v_toolbar, { flat: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar_title, null, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("Groups")
                              ])),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_divider, {
                              class: "mx-4",
                              inset: "",
                              vertical: ""
                            }),
                            _createVNode(_component_m_btn, {
                              color: "primary",
                              "prepend-icon": "mdi-plus",
                              onClick: $setup.openAddGroupDialog
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode("Add")
                              ])),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _createVNode(_component_m_btn, {
                              class: "ml-2",
                              color: "primary",
                              "prepend-icon": "mdi-merge",
                              onClick: $setup.openMergeDialog
                            }, {
                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                _createTextVNode("Merge")
                              ])),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _createVNode(_component_m_btn, {
                              class: "ml-2",
                              color: "primary",
                              "prepend-icon": "mdi-refresh",
                              onClick: $setup.loadGroups
                            }, {
                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                _createTextVNode("Refresh")
                              ])),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      "item.actions": _withCtx(({ item }) => [
                        _createVNode(_component_v_btn, {
                          icon: "",
                          size: "small",
                          variant: "text",
                          color: "primary",
                          onClick: _withModifiers(($event: any) => ($setup.openEditGroupDialog(item)), ["stop"]),
                          title: "Edit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createTextVNode("mdi-pencil")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          size: "small",
                          variant: "text",
                          color: "error",
                          onClick: _withModifiers(($event: any) => ($setup.confirmDeleteGroup(item)), ["stop"]),
                          title: "Delete"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createTextVNode("mdi-trash-can-outline")
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                      ]),
                      "item.groupId": _withCtx(({ item }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'font-weight-bold': $setup.selectedGroup?.groupId === item.groupId })
                        }, _toDisplayString(item.groupId), 3 /* TEXT, CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["headers", "items", "loading"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" User Assignment "),
            ($setup.selectedGroup)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  md: "7",
                  class: "d-flex",
                  style: {"height":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "text-left d-flex flex-column",
                      style: {"width":"100%","overflow":"hidden"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_overlay, {
                          "model-value": $setup.loadingUsers,
                          contained: "",
                          class: "align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              color: "primary"
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["model-value"]),
                        _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Users in Group: " + _toDisplayString($setup.selectedGroup.groupId) + " ", 1 /* TEXT */),
                            _createVNode(_component_v_chip, {
                              class: "ml-2",
                              size: "small",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.assignedUsers.length) + " assigned", 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }),
                            ($setup.hasUserChanges)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(unsaved changes)"))
                              : _createCommentVNode("v-if", true),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_m_btn, {
                              color: "primary",
                              size: "small",
                              disabled: !$setup.hasUserChanges,
                              onClick: $setup.saveUserChanges,
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("mdi-content-save")
                                  ])),
                                  _: 1 /* STABLE */
                                }),
                                _cache[25] || (_cache[25] = _createTextVNode(" Save "))
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"]),
                            _createVNode(_component_m_btn, {
                              size: "small",
                              disabled: !$setup.hasUserChanges,
                              onClick: $setup.resetUserChanges
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createTextVNode("mdi-refresh")
                                  ])),
                                  _: 1 /* STABLE */
                                }),
                                _cache[27] || (_cache[27] = _createTextVNode(" Reset "))
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_card_subtitle, { class: "text-caption" }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createTextVNode(" Users in other groups are shown with a group indicator. For bulk or cross-group assignment, use the \"Assign Users to Groups\" page. ")
                          ])),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_card_text, {
                          class: "d-flex flex-column",
                          style: {"flex":"1","overflow":"hidden","min-height":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createCommentVNode(" Fixed header: labels, search, and transfer buttons "),
                            _createVNode(_component_v_row, {
                              class: "flex-grow-0",
                              align: "end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "5" }, {
                                  default: _withCtx(() => [
                                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Available Users", -1 /* HOISTED */)),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.availableUserSearch,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.availableUserSearch) = $event)),
                                      "prepend-inner-icon": "mdi-magnify",
                                      label: "Search",
                                      variant: "outlined",
                                      density: "compact",
                                      "hide-details": "",
                                      clearable: ""
                                    }, null, 8 /* PROPS */, ["modelValue"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "2",
                                  class: "d-flex flex-column align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_m_btn, {
                                      class: "mb-2",
                                      color: "primary",
                                      size: "small",
                                      disabled: !$setup.selectedAvailableUser,
                                      onClick: $setup.addUserLocal,
                                      block: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                                            _createTextVNode("mdi-chevron-right")
                                          ])),
                                          _: 1 /* STABLE */
                                        }),
                                        _cache[31] || (_cache[31] = _createTextVNode(" Add "))
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled", "onClick"]),
                                    _createVNode(_component_m_btn, {
                                      color: "error",
                                      size: "small",
                                      disabled: !$setup.selectedAssignedUser,
                                      onClick: $setup.removeUserLocal,
                                      block: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                                            _createTextVNode("mdi-chevron-left")
                                          ])),
                                          _: 1 /* STABLE */
                                        }),
                                        _cache[33] || (_cache[33] = _createTextVNode(" Remove "))
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled", "onClick"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "5" }, {
                                  default: _withCtx(() => [
                                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Assigned Users", -1 /* HOISTED */)),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: $setup.assignedUserSearch,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.assignedUserSearch) = $event)),
                                      "prepend-inner-icon": "mdi-magnify",
                                      label: "Search",
                                      variant: "outlined",
                                      density: "compact",
                                      "hide-details": "",
                                      clearable: ""
                                    }, null, 8 /* PROPS */, ["modelValue"])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" Scrollable user lists "),
                            _createVNode(_component_v_row, {
                              class: "flex-grow-1 mt-2",
                              style: {"overflow":"hidden","min-height":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "5",
                                  class: "d-flex",
                                  style: {"height":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      density: "compact",
                                      class: "user-list",
                                      lines: "two"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredAvailableUsers, (user) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: user.userId,
                                            value: user.userId,
                                            active: $setup.selectedAvailableUser?.userId === user.userId,
                                            onClick: ($event: any) => ($setup.selectedAvailableUser = user)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.displayUser(user)), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */),
                                              (user.groupId)
                                                ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                    key: 0,
                                                    class: "text-caption text-warning"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" Currently in: " + _toDisplayString(user.groupId), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                  }, 1024 /* DYNAMIC_SLOTS */))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "active", "onClick"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "2" }),
                                _createVNode(_component_v_col, {
                                  cols: "5",
                                  class: "d-flex",
                                  style: {"height":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      density: "compact",
                                      class: "user-list",
                                      lines: "one"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredAssignedUsers, (user) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: user.userId,
                                            value: user.userId,
                                            active: $setup.selectedAssignedUser?.userId === user.userId,
                                            onClick: ($event: any) => ($setup.selectedAssignedUser = user)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.displayUser(user)), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                              }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "active", "onClick"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Add/Edit Group Dialog "),
        _createVNode(_component_v_dialog, {
          modelValue: $setup.showGroupDialog,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.showGroupDialog) = $event)),
          "max-width": "500",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.editingGroup ? 'Edit Group' : 'Add Group'), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: $setup.groupForm.groupName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.groupForm.groupName) = $event)),
                      label: "Group Name *",
                      variant: "outlined",
                      density: "comfortable",
                      maxlength: "10",
                      disabled: !!$setup.editingGroup,
                      class: "mb-2"
                    }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: $setup.groupForm.groupDesc,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.groupForm.groupDesc) = $event)),
                      label: "Description *",
                      variant: "outlined",
                      density: "comfortable",
                      maxlength: "64"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_m_btn, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showGroupDialog = false)),
                      text: "Cancel"
                    }),
                    _createVNode(_component_m_btn, {
                      color: "primary",
                      onClick: $setup.submitGroup,
                      text: $setup.editingGroup ? 'Update' : 'Add',
                      disabled: !$setup.groupForm.groupName || !$setup.groupForm.groupDesc
                    }, null, 8 /* PROPS */, ["onClick", "text", "disabled"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" Delete Confirm Dialog "),
        _createVNode(_component_v_dialog, {
          modelValue: $setup.showDeleteDialog,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.showDeleteDialog) = $event)),
          "max-width": "400"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                    _createTextVNode("Confirm Delete")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Are you sure you want to delete group \"" + _toDisplayString($setup.deletingGroup?.groupId) + "\"?", 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_m_btn, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showDeleteDialog = false)),
                      text: "Cancel"
                    }),
                    _createVNode(_component_m_btn, {
                      color: "error",
                      onClick: $setup.deleteGroup,
                      text: "Delete"
                    }, null, 8 /* PROPS */, ["onClick"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" Merge Groups Dialog "),
        _createVNode(_component_v_dialog, {
          modelValue: $setup.showMergeDialog,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.showMergeDialog) = $event)),
          "max-width": "500",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                    _createTextVNode("Merge Groups")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-body-2 mb-4" }, " Move all members from the source group into the target group. ", -1 /* HOISTED */)),
                    _createVNode(_component_v_select, {
                      modelValue: $setup.mergeForm.sourceGroup,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.mergeForm.sourceGroup) = $event)),
                      items: $setup.groups,
                      "item-title": "groupId",
                      "item-value": item => item,
                      label: "Source Group (merge from)",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-1"
                    }, {
                      item: _withCtx(({ item, props }) => [
                        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                          subtitle: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.raw.groupDesc), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "items", "item-value"]),
                    ($setup.sourceMemberCount !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            color: "info",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.sourceMemberCount), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createTextVNode(" member" + _toDisplayString($setup.sourceMemberCount === 1 ? '' : 's') + " in source group ", 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_select, {
                      modelValue: $setup.mergeForm.targetGroup,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.mergeForm.targetGroup) = $event)),
                      items: $setup.mergeTargetGroups,
                      "item-title": "groupId",
                      "item-value": item => item,
                      label: "Target Group (merge into)",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-1"
                    }, {
                      item: _withCtx(({ item, props }) => [
                        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                          subtitle: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.raw.groupDesc), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "items", "item-value"]),
                    ($setup.targetMemberCount !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_v_chip, {
                            size: "x-small",
                            color: "info",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.targetMemberCount), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createTextVNode(" member" + _toDisplayString($setup.targetMemberCount === 1 ? '' : 's') + " in target group ", 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_checkbox, {
                      modelValue: $setup.mergeForm.deleteSource,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.mergeForm.deleteSource) = $event)),
                      label: "Delete source group after merge",
                      density: "comfortable",
                      "hide-details": ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                ($setup.mergeResultCount !== null)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "success",
                      variant: "tonal",
                      density: "compact",
                      class: "mx-4 mb-2"
                    }, {
                      default: _withCtx(() => [
                        _cache[38] || (_cache[38] = _createTextVNode(" Merge complete — target group now has ")),
                        _createElementVNode("strong", null, _toDisplayString($setup.mergeResultCount), 1 /* TEXT */),
                        _createTextVNode(" member" + _toDisplayString($setup.mergeResultCount === 1 ? '' : 's') + ". ", 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    ($setup.mergeResultCount !== null)
                      ? (_openBlock(), _createBlock(_component_m_btn, {
                          key: 0,
                          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.showMergeDialog = false)),
                          text: "Close"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_m_btn, {
                            onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.showMergeDialog = false)),
                            text: "Cancel"
                          }),
                          _createVNode(_component_m_btn, {
                            color: "primary",
                            onClick: $setup.executeMerge,
                            text: "Merge",
                            disabled: !$setup.mergeForm.sourceGroup || !$setup.mergeForm.targetGroup
                          }, null, 8 /* PROPS */, ["onClick", "disabled"])
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}